import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Shipment } from 'services/action';
import { Form } from 'ui/components';

const initialState = {
  reason: null,
};

export const FormReason = ({ onSubmit, data }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);
  const [{ reason }, setState] = React.useState(initialState);

  const $handleSubmit = async (e) => {
    const payload = {reason};
    const req = await Dispatch(Shipment.$void(data?.id, payload));

    if (req?.message === 'success') {
      onSubmit();
    }
  };

  return (
    <Form autoComplete="off">
      <div className="row text-start">
        <div className="col-md-12">
          <Form.Textbox
            required
            label="Alasan"
            value={reason}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                reason: e.target.value,
              }))
            }
            error={StateForm?.errors?.reason}
          />
        </div>
      </div>

      <button
        className={
          StateForm?.loading
            ? 'btn-loading btn btn-primary px-3 w-100 mb-3'
            : 'btn btn-primary px-3 w-100 mb-3'
        }
        onClick={$handleSubmit}
        type="button"
        disabled={StateForm?.loading}
      >
        Simpan
      </button>
    </Form>
  );
};
